export default __webpack_public_path__ + "static/media/5.fdd1274e.png";